import React from 'react';
import GameActiveVideoScene from '../../gameActiveVideoScene';

const Game = () => {
  return (
    <div className='oddball-game-line-wrp'>
      <GameActiveVideoScene />
    </div>
  );
};

export default Game;
